// GraphQL Queries and Mutations for Notification Service

// Field selections for notification queries
export const NOTIFICATION_SELECTION = `
  id
  title
  content
  type
  status
  priority
  createdAt
  updatedAt
`;

// GraphQL Queries
export const NOTIFICATION_QUERIES = {
  GET_NOTIFICATIONS: `
    query GetNotifications($page: Int, $where: Notification_where, $limit: Int) {
      Notifications(where: $where, page: $page, limit: $limit) {
        docs {
          {{selection}}
        }
        page
        limit
        totalDocs
        totalPages
      }
    }
  `
};

// GraphQL Mutations
export const NOTIFICATION_MUTATIONS = {
  MARK_AS_READ: `
    mutation MarkAsRead($input: MarkNotificationAsReadInput) {
      markNotificationAsRead(input: $input) {
        success
        message
      }
    }
  `,

  MARK_ALL_AS_READ: `
    mutation MarkAllAsRead {
      markAllAsRead {
        success
        message
      }
    }
  `
};

// Response paths for custom GraphQL client
export const NOTIFICATION_RESPONSE_PATHS = {
  GET_NOTIFICATIONS: {
    DATA: "data.Notifications.docs",
    PARAMS: "data.Notifications",
    ERRORS: "errors"
  },
  MARK_AS_READ: {
    DATA: "data.markNotificationAsRead",
    PARAMS: "",
    ERRORS: "errors"
  },
  MARK_ALL_AS_READ: {
    DATA: "data.markAllAsRead",
    PARAMS: "",
    ERRORS: "errors"
  }
};